import { kebabCase } from 'lodash';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import { AppFeature } from '../../types/api/graphql';

export const useHealthProviderFeatureValues = () => {
  const intl = useIntl();

  const data = useMemo(
    () =>
      Object.values(AppFeature)
        .filter(option => option !== AppFeature.AppFeatureSet)
        .map(option => ({
          key: option,
          title: intl.formatMessage({
            id: `common.feature.${kebabCase(option)}`,
          }),
        })),
    [intl]
  );

  return {
    data,
    loading: false,
  };
};
